import * as GeneralTraits from './traits.shared'

export type T = DisplayableInCharts
type DisplayableInCharts = GeneralTraits.T<'chartsSeriesDisplay', Params>

export type Template = 'single-property' | 'supplier-meter'

export type Params = {
  template: Template
}

export type Name = keyof DisplayableInCharts
export const name = 'chartsSeriesDisplay'

export const isDisplayableInCharts = (traits: GeneralTraits.T<string, any>): traits is DisplayableInCharts => traits?.chartsSeriesDisplay != null

export const templateOf = (traits: DisplayableInCharts): Template => traits.chartsSeriesDisplay.template

export const isSingleProperty = (traits: GeneralTraits.T<string, any>): boolean => isDisplayableInCharts(traits) && templateOf(traits) === 'single-property'
export const isSupplierMeter = (traits: GeneralTraits.T<string, any>): boolean => isDisplayableInCharts(traits) && templateOf(traits) === 'supplier-meter'

export type SinglePropertyAttributesKeys = 'value'
export type SupplierMeterAttributesKeys = 'total' | 'tariffs'

